import { cn } from "@/lib/utils";
import type { ReactNode } from "react";

type Props = {
  eyebrow?: string | undefined;
  title: ReactNode;
  subtitle?: string | undefined;
  align?: "left" | "center" | undefined;
  className?: string | undefined;
};

export function SectionHeading({ eyebrow, title, subtitle, align = "center", className }: Props) {
  return (
    <header
      className={cn(
        "flex flex-col gap-3",
        align === "center" ? "items-center text-center" : "items-start text-left",
        className,
      )}
    >
      {eyebrow ? <p className="label-xs text-accent">{eyebrow}</p> : null}
      <h2 className="text-3xl leading-tight tracking-[0.01em] text-foreground sm:text-4xl md:text-[2.75rem]">
        {title}
      </h2>
      {subtitle ? (
        <p className="max-w-xl text-sm leading-relaxed text-muted-foreground sm:text-base">
          {subtitle}
        </p>
      ) : null}
    </header>
  );
}
